import Text from "./text";
export default Text;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/text/index.ts
// module id = s7mA
// module chunks = 2